export default "__VITE_ASSET__Ca03I7fw__"